const xmlns = 'http://www.w3.org/2000/svg';
const xlinkns = 'http://www.w3.org/1999/xlink';
const embedAttr = 'data-grunticon-embed';

class IconEmbed {
  constructor() {
    this.instances = document.querySelectorAll(`[${embedAttr}]`);

    this.loadSpriteSheet();

    [...this.instances].forEach((icon) => this.addIcon(icon));
  }

  getIconName(el) {
    return [...el.classList].find(
      (className) => className.startsWith('icon') && className !== 'icon'
    );
  }

  createNewElement(name) {
    const svg = document.createElementNS(xmlns, 'svg');
    const use = document.createElementNS(xmlns, 'use');

    svg.setAttribute('aria-hidden', true);
    use.setAttributeNS(xlinkns, 'href', `#${name}`);

    svg.appendChild(use);

    return svg;
  }

  addIcon(el) {
    const iconName = this.getIconName(el);
    const svg = this.createNewElement(iconName);
    el.removeAttribute(embedAttr);

    return el.appendChild(svg);
  }

  loadSpriteSheet() {
    fetch('/wp-content/themes/cloverpipe/static/dist/icons/symbols.svg')
      .then((res) => res.text())
      .then((svgText) => {
        const svgHider = document.createElement('div');

        svgHider.innerHTML = svgText;
        svgHider.classList.add('u-is-hidden');

        document.body.append(svgHider);
      });
  }
}

document.addEventListener('DOMContentLoaded', () => new IconEmbed());
